@if (params.isEditing()) {
  @let context = params.editContext();

  <ng-select
    [(ngModel)]="context[params.node.rowIndex].selectedPriceId"
    [items]="params.stripeProductPrices()"
    bindValue="id"
    bindLabel="product.name"
    class="w-full"
    placeholder="Plan..."
    appendTo="body"
    [disabled]="params.isSaving()"
  ></ng-select>
} @else {
  {{ getStripeProductPriceById(params.data.stripePriceId) }}
}
